import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FactoryIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M2.4555 1C2.18824 1 1.96642 1.20272 1.94738 1.46438L1.83562 3H4.16438L4.05262 1.46438C4.03358 1.20272 3.81176 1 3.5445 1H2.4555Z"
		></path>
		<path
			fill="currentColor"
			d="M4.23715 4H1.76285L1.00132 14.4644C0.980258 14.7538 1.21381 15 1.50944 15H4.49056C4.78619 15 5.01974 14.7538 4.99868 14.4644L4.23715 4Z"
		></path>
		<path
			fill="currentColor"
			d="M6 8.42192V10H15V6.48516C15 6.05379 14.4614 5.83776 14.1464 6.14279L12 8.22136V6.48516C12 6.05379 11.4614 5.83776 11.1464 6.14279L9 8.22136V6.48516C9 6.05379 8.46143 5.83776 8.14645 6.14279L6.14645 8.07954C6.05268 8.17034 6 8.2935 6 8.42192Z"
		></path>
		<path
			fill="currentColor"
			d="M6 14.5158V11H15V14.5158C15 14.7832 14.7761 15 14.5 15H6.5C6.22386 15 6 14.7832 6 14.5158Z"
		></path>
	</svg>
))
